import config from "../config.js";
import RequestManager from "./request.js";

export default class Region {
    static async getMyRegion() {
        try {
            const url = `${config.urlBackEnd}Region/GetMyRegion`;
            console.log("URL appelée :", url);
            const response = await RequestManager.get(url);
            console.log("Réponse reçue :", response);
            return response;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log("Aucune région n'a été trouvée.")
            } else {
                console.error("Erreur lors de la récupération de ma région", error);
            }
            throw error;
        }
    }

    static async getOneRegion(regionName) {
        try {
            const url = `${config.urlBackEnd}Region/GetOneRegion?regionName=${regionName}`;
            const response = await RequestManager.get(url);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération d'une région (", regionName, ") :", error);
            throw error;
        }
    }

    static async saveRegion(regionName) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Region/SaveRegion?regionName=${regionName}`);
            console.log(response);
            return response;
        } catch (error) {
            console.error("Erreur lors de l'enregistrement de la région :", error);
            throw error;
        }
    }
}
